import { render, staticRenderFns } from "./JsonPreview.vue?vue&type=template&id=9d36b77a&"
import script from "./JsonPreview.vue?vue&type=script&lang=js&"
export * from "./JsonPreview.vue?vue&type=script&lang=js&"
import style0 from "./JsonPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports